import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface CodeResultProps {
  code: string;
  language?: string;
}

const CodeResult: React.FC<CodeResultProps> = ({ code, language }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDownload = () => {
    const blob = new Blob([code], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const extension = language === 'python' ? 'py' : language;
    a.download = `code.${extension || 'txt'}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (

    <div className="bg-[var(--rhea-bg-tertiary)] rounded p-3 w-full h-full">
      {language && (
        <div className="text-xs text-[var(--rhea-text-secondary)] mt-1">
          {language}
        </div>
      )}
      <div className="relative group">
        <div className="absolute right-2 top-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={handleCopy}
            className="px-2 py-1 text-xs bg-gray-700 rounded hover:bg-gray-600"
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
          <button
            onClick={handleDownload}
            className="px-2 py-1 text-xs bg-gray-700 rounded hover:bg-gray-600"
          >
            Download
          </button>
        </div>
        <SyntaxHighlighter
          style={vscDarkPlus as any}
          language={language || 'text'}
          PreTag="div"
        >
          {code}
        </SyntaxHighlighter>
      </div>

    </div>
  );
};

export default CodeResult; 